/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpResponse, HttpContext, HttpParams } from '@angular/common/http';
import { DataBaseService } from '../data-base-service';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { GenericView } from '../models/generic-view';
import { GenericViewEndUserDto } from '../models/generic-view-end-user-dto';
import { GenericViewPermissionsDtoPartialExcludingIdCreationInfoUpdateInfo } from '../models/generic-view-permissions-dto-partial-excluding-id-creation-info-update-info';
import { GenericViewWithRelations } from '../models/generic-view-with-relations';
import { NewGenericView } from '../models/new-generic-view';
import { GenericPermissionsDto } from '../models/generic-permissions-dto';
import { Count as LoopbackCount } from '../models/loopback/count';

@Injectable({ providedIn: 'root' })
export class GenericViewControllerService extends DataBaseService {

  /**
   * Path part for operation genericViewControllerCount
   */
  static readonly GenericViewControllerCountPath = '/v1/generic-views/count';

  /**
   * Count of GenericViews
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `count()` instead.
   *
   * This method doesn't expect any request body.
   */
  count$Response(params?: {
    where?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<LoopbackCount>> {

    const rb = new RequestBuilder(this.rootUrl, GenericViewControllerService.GenericViewControllerCountPath, 'get');
    if (params) {
      rb.query('where', params.where, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoopbackCount>;
      })
    );
  }
  /**
   * Count of GenericViews
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `count$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  count(params?: {
    where?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<LoopbackCount> {

    return this.count$Response(params).pipe(
      map((r: StrictHttpResponse<LoopbackCount>) => r.body as LoopbackCount)
    );
  }

  /**
   * Path part for operation genericViewControllerGetUserDefaultView
   */
  static readonly GenericViewControllerGetUserDefaultViewPath = '/v1/generic-views/default';

  /**
   * return the default view for the user
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserDefaultView()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserDefaultView$Response(params?: {
    relatedTo?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<GenericPermissionsDto>> {

    const rb = new RequestBuilder(this.rootUrl, GenericViewControllerService.GenericViewControllerGetUserDefaultViewPath, 'get');
    if (params) {
      rb.query('relatedTo', params.relatedTo, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GenericPermissionsDto>;
      })
    );
  }
  /**
   * return the default view for the user
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getUserDefaultView$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserDefaultView(params?: {
    relatedTo?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<GenericPermissionsDto> {

    return this.getUserDefaultView$Response(params).pipe(
      map((r: StrictHttpResponse<GenericPermissionsDto>) => r.body as GenericPermissionsDto)
    );
  }

  /**
   * Path part for operation genericViewControllerFindByIdEndUser
   */
  static readonly GenericViewControllerFindByIdEndUserPath = '/v1/generic-views/end-user/{id}';

  /**
   * Return single generic view by Id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findByIdEndUser()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  findByIdEndUser$Response(params: {
    id: string;
    filter?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<GenericPermissionsDto>> {

    const rb = new RequestBuilder(this.rootUrl, GenericViewControllerService.GenericViewControllerFindByIdEndUserPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GenericPermissionsDto>;
      })
    );
  }
  /**
   * Return single generic view by Id
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findByIdEndUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  findByIdEndUser(params: {
    id: string;
    filter?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<GenericPermissionsDto> {

    return this.findByIdEndUser$Response(params).pipe(
      map((r: StrictHttpResponse<GenericPermissionsDto>) => r.body as GenericPermissionsDto)
    );
  }

  /**
   * Path part for operation genericViewControllerFindById
   */
  static readonly GenericViewControllerFindByIdPath = '/v1/generic-views/{id}';

  /**
   * Return single generic view by Id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findById()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById$Response(params: {
    id: string;
    filter?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<GenericPermissionsDto>> {

    const rb = new RequestBuilder(this.rootUrl, GenericViewControllerService.GenericViewControllerFindByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GenericPermissionsDto>;
      })
    );
  }
  /**
   * Return single generic view by Id
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById(params: {
    id: string;
    filter?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<GenericPermissionsDto> {

    return this.findById$Response(params).pipe(
      map((r: StrictHttpResponse<GenericPermissionsDto>) => r.body as GenericPermissionsDto)
    );
  }

  /**
   * Path part for operation genericViewControllerDeleteById
   */
  static readonly GenericViewControllerDeleteByIdPath = '/v1/generic-views/{id}';

  /**
   * Delete specific generic view by Id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById$Response(params: {
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, GenericViewControllerService.GenericViewControllerDeleteByIdPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }
  /**
   * Delete specific generic view by Id
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById(params: {
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<any> {

    return this.deleteById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation genericViewControllerUpdateById
   */
  static readonly GenericViewControllerUpdateByIdPath = '/v1/generic-views/{id}';

  /**
   * Update specific generic view by Id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById$Response(params: {
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: GenericViewPermissionsDtoPartialExcludingIdCreationInfoUpdateInfo
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, GenericViewControllerService.GenericViewControllerUpdateByIdPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }
  /**
   * Update specific generic view by Id
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById(params: {
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: GenericViewPermissionsDtoPartialExcludingIdCreationInfoUpdateInfo
  }): Observable<any> {

    return this.updateById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation genericViewControllerFind
   */
  static readonly GenericViewControllerFindPath = '/v1/generic-views';

  /**
   * List all generic views
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `find()` instead.
   *
   * This method doesn't expect any request body.
   */
  find$Response(params?: {
    filter?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Array<GenericViewWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, GenericViewControllerService.GenericViewControllerFindPath, 'get');
    if (params) {
      rb.query('filter', params.filter, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<GenericViewWithRelations>>;
      })
    );
  }
  /**
   * List all generic views
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `find$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  find(params?: {
    filter?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Array<GenericViewWithRelations>> {

    return this.find$Response(params).pipe(
      map((r: StrictHttpResponse<Array<GenericViewWithRelations>>) => r.body as Array<GenericViewWithRelations>)
    );
  }

  /**
   * Path part for operation genericViewControllerCreate
   */
  static readonly GenericViewControllerCreatePath = '/v1/generic-views';

  /**
   * Create new GenericView
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `create()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create$Response(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
    body?: NewGenericView
  }): Observable<StrictHttpResponse<GenericView>> {

    const rb = new RequestBuilder(this.rootUrl, GenericViewControllerService.GenericViewControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GenericView>;
      })
    );
  }
  /**
   * Create new GenericView
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `create$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
    body?: NewGenericView
  }): Observable<GenericView> {

    return this.create$Response(params).pipe(
      map((r: StrictHttpResponse<GenericView>) => r.body as GenericView)
    );
  }

  /**
   * Path part for operation genericViewControllerFindByIdEndUserV2
   */
  static readonly GenericViewControllerFindByIdEndUserV2Path = '/v2/generic-views/end-user/{id}';

  /**
   * Return a dto containing either redirection rule or components based on matching rules
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findByIdEndUserV2()` instead.
   *
   * This method doesn't expect any request body.
   */
  findByIdEndUserV2$Response(params: {
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<GenericViewEndUserDto>> {

    const rb = new RequestBuilder(this.rootUrl, GenericViewControllerService.GenericViewControllerFindByIdEndUserV2Path, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GenericViewEndUserDto>;
      })
    );
  }
  /**
   * Return a dto containing either redirection rule or components based on matching rules
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findByIdEndUserV2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findByIdEndUserV2(params: {
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<GenericViewEndUserDto> {

    return this.findByIdEndUserV2$Response(params).pipe(
      map((r: StrictHttpResponse<GenericViewEndUserDto>) => r.body as GenericViewEndUserDto)
    );
  }

}
